import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Training Certificate Information ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { id: "pdf" }
const _hoisted_7 = { class: "card-body border-top p-6" }
const _hoisted_8 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_9 = { class: "card mb-5 mb-xl-10" }
const _hoisted_10 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_11 = { class: "collapse show" }
const _hoisted_12 = { class: "card-body border-top" }
const _hoisted_13 = { class: "logo" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  style: {"float":"left","margin-left":"87px","margin-top":"77px","height":"53px","width":"133px"},
  src: "https://seeklogo.com/images/S/seip-skills-for-employment-investment-program-logo-57AF59698D-seeklogo.com.png",
  alt: "Logo 1"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-left":"24%","margin-top":"69px","height":"58px","width":"120px","float":"left"},
  src: "https://cdn.worldvectorlogo.com/logos/bangladesh-govt-logo-vector.svg",
  alt: "Logo 1"
}, null, -1)
const _hoisted_16 = { style: {"float":"left","margin-left":"-524px","margin-top":"156px"} }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "certificate-content" }
const _hoisted_19 = { class: "box" }
const _hoisted_20 = {
  class: "center",
  style: {"font-famly":"Olde-English"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "Certificate in ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "sublinhar serif h3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  class: "esquerda",
  style: {"text-align":"center"}
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "h3 negrito-2 serif text-uppercase" }, "is awarded to", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "sublinhar serif h3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_30 = {
  class: "serif pt-3",
  style: {"text-align":"justify"}
}
const _hoisted_31 = { style: {"text-align":"justify","padding":"48px"} }
const _hoisted_32 = { class: "sublinhar negrito" }
const _hoisted_33 = { class: "sublinhar negrito" }
const _hoisted_34 = { class: "sublinhar negrito" }
const _hoisted_35 = { class: "sublinhar negrito" }
const _hoisted_36 = { class: "sublinhar negrito" }
const _hoisted_37 = { class: "sublinhar negrito" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10%"} }, null, -1)
const _hoisted_39 = {
  class: "d-flex justify-content-between",
  style: {"width":"90%","margin":"0 auto"}
}
const _hoisted_40 = {
  key: 0,
  style: {"width":"17%"}
}
const _hoisted_41 = ["src"]
const _hoisted_42 = { style: {"width":"80px","height":"80px"} }
const _hoisted_43 = {
  key: 1,
  style: {"width":"17%"}
}
const _hoisted_44 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "d-flex justify-content-end btn btn-sm btn-success",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadCertificate && _ctx.downloadCertificate(...args)))
          }, " Download "),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ 'background-image': 'url(' + this.VUE_APP_API_URL + '/storage/images/CertificateBackground/ttt.gif' + ')', 'background-repeat': 'no-repeat' }),
                          class: "certificate"
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _hoisted_15,
                            _createElementVNode("h3", _hoisted_16, " Registration No : " + _toDisplayString(_ctx.registration_number), 1),
                            _createElementVNode("img", {
                              style: {"float":"right","margin-right":"85px","margin-top":"70px","height":"81px","width":"137px"},
                              src: `${this.VUE_APP_API_URL}${_ctx.entityInfos[0]?.file_path}`,
                              alt: "Logo 2"
                            }, null, 8, _hoisted_17)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("p", _hoisted_20, [
                                _hoisted_21,
                                _hoisted_22,
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.course_name), 1),
                                _createTextVNode(),
                                _hoisted_24,
                                _createElementVNode("p", _hoisted_25, [
                                  _hoisted_26,
                                  _hoisted_27,
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.name), 1)
                                ])
                              ]),
                              _hoisted_29,
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("p", _hoisted_31, [
                                  _createTextVNode(" Son/Daughter of "),
                                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.father_name), 1),
                                  _createTextVNode(" and "),
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.mother_name), 1),
                                  _createTextVNode(" for having achieved the units of competency through training program "),
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.hour), 1),
                                  _createTextVNode(" hours held from "),
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.course_start), 1),
                                  _createTextVNode(" to "),
                                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.course_end), 1),
                                  _createTextVNode(" at "),
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.address), 1),
                                  _createTextVNode(" supported by the Skills for Employment Investment Program (SEIP), Finance Division, Ministry Of Finance, Government of Bangladesh. ")
                                ])
                              ])
                            ])
                          ]),
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            (_ctx.BackgroundInfos.left)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("p", null, [
                                    (_ctx.BackgroundInfos.left?.[0]?.left_signature)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          style: {"height":"50px","width":"100px"},
                                          src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.left?.[0]?.left_signature}`,
                                          alt: "Logo 2"
                                        }, null, 8, _hoisted_41))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.left?.[0]?.left_signatory), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_qrcode_vue, { value: _ctx.qrData }, null, 8, ["value"])
                            ]),
                            (_ctx.BackgroundInfos.right)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createElementVNode("p", null, [
                                    (_ctx.BackgroundInfos.right?.[0]?.right_signature)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          style: {"height":"50px","width":"100px"},
                                          src: `${this.VUE_APP_API_URL}${_ctx.BackgroundInfos.right?.[0]?.right_signature}`,
                                          alt: "Logo 2"
                                        }, null, 8, _hoisted_44))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.BackgroundInfos.right?.[0]?.right_signatory), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 4)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.isLoading]
        ])
      ])
    ])
  ]))
}